<div class="bg-image">
    &nbsp;&nbsp;
    <div class="container">
        <mat-card-content>
            <div class="row"
                style="padding-top: 2px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
                <div class="td-col-md-2" style="width: 5%;" class="mobileview"></div>
                <div style="width: 90%;border-width: 2px; ">
                    <mat-card>
                        <mat-card tabindex="0"
                            style="color:white; background-color: #11446f; border: 1px solid #f1b122;">
                            <mat-card-content>Building A Shared Vision Together</mat-card-content>
                        </mat-card>
                        <div class="card">
                            <div class="card-body">
                                <div class="card-text p-1">

                                    Welcome to the MyJax Community Connect. This dashboard highlights the City of
                                    Jacksonville’s quality of life investments within the ten community goals outlined
                                    in the <a
                                        onclick="window.open('https://nonprofits.coj.net/StrategicPartnerships/CommunityGoalsFramework.aspx','_blank')"
                                        style="color: #206aff; cursor: pointer;text-decoration: underline;">
                                        Community Goals
                                        Framework</a> and streamlines access to published reports and
                                    presentations. It provides an ‘at a glance’ look at the City’s investments for
                                    Fiscal Years 2019-22 utilizing interactive charts and tables, and it promotes
                                    transparency, alignment, and collaboration.
                                    <br>
                                    <br>

                                    The City of Jacksonville continues to build a strong foundation for informed
                                    decision-making by advancing systems to promote data-driven approaches and drive
                                    transformative change. The City’s investments are carefully evaluated and monitored
                                    to ensure they align with strategic goals and produce measurable benefits for
                                    Jacksonville residents. This investment dashboard and the framework are the
                                    inaugural tools with a vision to build a comprehensive metrics bank in the future
                                    that will profile the city’s performance story and guide strategic planning.
                                    <br>
                                    <br>

                                    By strengthening the connection between the City of Jacksonville and cross-sector
                                    partners, our community is better able to address complex community issues and
                                    leverage opportunities. This dashboard serves as a critical platform to engage with
                                    community members and partners by providing the necessary information to shape the
                                    future of our city. We must work together to create a more vibrant, thriving city
                                    for all Jacksonville residents.
                                    <br>
                                    <br>

                                    <strong style="text-decoration: underline;"> Purpose: </strong>
                                </div>
                                <div>
                                    <ul>
                                        <li>Increase effectiveness and improve community outcomes by effectively
                                            addressing
                                            challenges with solutions grounded in rigorous, evidence-based policymaking
                                            and
                                            data.</li>
                                        <li>Promote performance excellence through successful data management and commit
                                            to
                                            public transparency and a continuous improvement culture.</li>
                                        <li>Improve accessibility and usability of data so partners and community
                                            members
                                            can identify opportunities and aid with strategies to solve community issues
                                            and
                                            create positive impact.</li>
                                        <li>Identify cost savings, increase efficiency, eliminate silos, and create
                                            opportunities, as well as effectively execute strategic goals through
                                            public,
                                            private, and philanthropic sector collaboration.</li>

                                    </ul>
                                </div>
                                <strong style="text-decoration: underline;"> Disclaimer:</strong>
                                Information contained on this site is for general information purposes only. Every
                                effort has been made to provide information that is current and accurate. Nevertheless,
                                inadvertent data errors may occur, and the data on this site may not show a complete
                                picture of the City of Jacksonville’s quality-of-life funding investments. Most City of
                                Jacksonville staff salaries are not included in this analysis.
                            </div>
                        </div>
                    </mat-card>
                </div>
            </div>
        </mat-card-content>
        <mat-card-content>

            <div class="row"
                style="padding-top: 2px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
                <div class="td-col-md-2" style="width: 5%;" class="mobileview"></div>
                <div style="width: 90%;border-width: 2px; ">

                    <mat-card>


                        <div class="card-body">

                            <div class=" row col-md-12">
                                <div class="col-md-4">

                                    <mat-card tabindex="0"
                                        style="color:white; background-color: #008078;text-align:center;">
                                        <mat-card-content>Dashboard</mat-card-content>
                                    </mat-card>


                                    <mat-card>

                                        <img mat-card-image src="../../assets/images/dashboard.jpg"
                                            alt="Photo of a Dashboard" />

                                        <mat-card-content>
                                            <p>

                                                {{Dashboardtext}}

                                            </p>
                                        </mat-card-content>
                                        <mat-card-actions align="center">

                                            <button style="background-color: #008078;color:white;"
                                                (click)="GoBacktoDashboard();" mat-button>Dashboard</button>



                                        </mat-card-actions>
                                    </mat-card>

                                </div>

                                <div class="col-md-4">

                                    <mat-card tabindex="0"
                                        style="color:white; background-color: #008078;text-align:center;">
                                        <mat-card-content>Community Goals Framework</mat-card-content>
                                    </mat-card>

                                    <mat-card>



                                        <img mat-card-image src="../../assets/images/cgfdashboard.jpg"
                                            alt="Photo of a CGF" />

                                        <mat-card-content>
                                            <p>

                                                {{CGFtext}}

                                            </p>
                                        </mat-card-content>
                                        <mat-card-actions align="center">

                                            <button style="background-color: #008078;color:white;"
                                                (click)="GotoResources();" mat-button>Community Goals Framework</button>




                                        </mat-card-actions>
                                    </mat-card>
                                </div>

                                <div class="col-md-4">
                                    <mat-card tabindex="0"
                                        style="color:white; background-color: #008078;text-align:center;">
                                        <mat-card-content>Resources</mat-card-content>
                                    </mat-card>
                                    <mat-card>
                                        <img mat-card-image src="../../assets/images/resourcesdashboard.jpg"
                                            alt="Photo of a CGF" />
                                        <mat-card-content>
                                            <p>
                                                {{Resourcestext}}
                                                <br>
                                                <br>
                                                <br>
                                            </p>
                                        </mat-card-content>
                                        <mat-card-actions align="center">
                                            <button style="background-color: #008078;color:white;"
                                                (click)="GotoResourcesPage();" mat-button>Resources</button>
                                        </mat-card-actions>
                                    </mat-card>
                                </div>
                            </div>
                        </div>
                    </mat-card>
                </div>
            </div>
        </mat-card-content>
        <br>
    </div>
</div>